var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('div',{attrs:{"id":"yt-player"}},[_c('div',{attrs:{"id":_vm.ytPlayerId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }